import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";

// COMPONENTS
import Wrapper from "../../../../components/helpers/Wrapper"
import Tab from "../../../../components/ui/Tab";
import FullPageExportContext from "../../../../store/fullPageExportContext";

// PAGES
import CampaignOverallOverall, { CampaignOverallOverallCoke } from "./CampaignOverallOverall";
import CampaignOverallVideo from "./CampaignOverallVideo";

// UTILS
import { IAEvent_Primary_Tab_Visit } from "../../../../utils/IAEvents";

// CONSTANT
import { COKE_COMPANY_ID, HALEON_COMPANY_ID, IDFC_COMPANY_ID, IMPRIVATA_COMPANY_ID, MPCB_COMPANY_ID, OLX_AUTOS_COMPANY_ID } from "../../../../constants/constants";


const CampaignOverall = ({ platformData }) => {
    const { exportSummary, setExportPageName } = useContext(FullPageExportContext);

    // USER DATA
    const userData = useSelector((state) => state.userData.user[0]);
    let companyID = userData?.company?.id ?? "";

    let tabData = [];

    if (companyID === COKE_COMPANY_ID || companyID === HALEON_COMPANY_ID || companyID === IDFC_COMPANY_ID || companyID === OLX_AUTOS_COMPANY_ID || companyID === IMPRIVATA_COMPANY_ID || companyID === MPCB_COMPANY_ID) {
        tabData = ["Overall"];
    } else {
        tabData = ["Overall", "Video"];
    }
    let CampaignOverall = [];
    if (companyID === COKE_COMPANY_ID) {
        CampaignOverall = <CampaignOverallOverallCoke topCardData={{ Summary: exportSummary, "PlatformCards_Platform Cards": platformData }} />
    }
    else {
        CampaignOverall = <CampaignOverallOverall topCardData={{ Summary: exportSummary, "PlatformCards_Platform Cards": platformData }} />
    }
    const [selectedTab, setSelectedTab] = useState(tabData[0]);

    const handleCallback = (event) => {
        if (selectedTab !== event) {
            setSelectedTab(event);
        }
        IAEvent_Primary_Tab_Visit("Marketing Intelligence", "Campaign", "Overall", event)
    };

    useEffect(() => {
        setExportPageName("Campaign " + selectedTab)
    }, [selectedTab])

    return (
        <Wrapper>
            <div className="grid grid_margin_bottom">
                <Tab
                    varient={"primary"}
                    tabData={tabData}
                    activeTab={selectedTab}
                    handleCallback={(event) => handleCallback(event)}
                />
            </div>
            {selectedTab.toLowerCase() === "overall" && CampaignOverall}
            {selectedTab.toLowerCase() === "video" && <CampaignOverallVideo topCardData={{ Summary: exportSummary, 'PlatformCards_Platform Cards': platformData }} />}

        </Wrapper>
    )
}

export default CampaignOverall;